import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { ProfilComponent } from './pages/parcours/profil/profil.component';
import { PortfolioComponent } from './pages/portfolio/portfolio-carrousel/portfolio.component';
import { BesoinclientComponent } from './pages/accueuil/besoinclient/besoinclient.component';
import { MesservicesComponent } from './pages/accueuil/messervices/messervices.component';
import { NotimplementedyetComponent } from './layout/notimplementedyet/notimplementedyet.component';
import { AccueuilComponent } from './pages/accueuil/accueuil.component';
import { RecommandationsComponent } from './pages/accueuil/recommandations/recommandations.component';
import { ContactComponent } from './pages/contact/contact.component';
import {FormsModule} from '@angular/forms';
import { ParcoursComponent } from './pages/parcours/parcours.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    ProfilComponent,
    PortfolioComponent,
    BesoinclientComponent,
    MesservicesComponent,
    NotimplementedyetComponent,
    AccueuilComponent,
    RecommandationsComponent,
    ContactComponent,
    ParcoursComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
